import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register Service Worker for PWA with reload protection (production only)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  // Prevent reload loops with a flag
  let isReloading = false;
  
  const safeReload = () => {
    if (isReloading) {
      console.log('[App] Reload already in progress, skipping...');
      return;
    }
    isReloading = true;
    // Small delay to prevent race conditions
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };
  
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('[App] SW registered:', registration.scope);
        
        // Check for updates on page load (debounced)
        setTimeout(() => registration.update(), 1000);
        
        // Listen for new service worker waiting
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New version available - auto refresh with protection
                console.log('[App] New version available, refreshing...');
                newWorker.postMessage('skipWaiting');
                safeReload();
              }
            });
          }
        });
      })
      .catch((error) => {
        console.log('[App] SW registration failed:', error);
      });
    
    // Listen for controller change - only reload once
    let controllerChanged = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (controllerChanged) {
        console.log('[App] Controller change already handled, skipping reload...');
        return;
      }
      controllerChanged = true;
      console.log('[App] Controller changed, reloading...');
      safeReload();
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
